import { createReducer, createAction } from 'redux-act'
import { selector as configSelector } from '~/config'
import {all, apply, put, select, takeEvery} from 'redux-saga/effects'

import { actions as productVideoActions } from './product-videos'
import { reduce } from 'lodash'

import {Entity, handleError} from '~/utils/entity-utils'

import API from '~/api'

const entityName = 'productVideoManager';
const entity = new Entity(entityName, API, configSelector);

// ACTIONS
export const actions = {
  ...entity.actions,
  sort: {
    request: createAction('sort videos request', (id, videos) => ({id, videos})),
    failure: createAction('sort videos failed', (message) => ({message})),
    success: createAction('sort videos success', (productVideoManager, response) => ({productVideoManager, response}))
  }
};

// WORKERS
export const workers = {
  ...entity.workers,
  * sort(action) {
    const { id, videos } = action.payload || {};
    try {
      const config = yield select(configSelector);
      const api = new API(config);
      const route = `product-video-managers/${id}/sort/`;
      const response = yield apply(api, api.callRoute, [route, 'POST', {
        videos
      }]);

      yield put(actions.sort.success(response.data, response));

      return response.data;
    } catch (e) {
      handleError(e, actions.sort);
      throw e;
    }
  }
};

// SAGA
export function * saga() {
  yield all([
    ...entity.saga,
    takeEvery(actions.sort.request().type, workers.sort),
  ]);
}

export const reducer = createReducer({
  ...entity.reducer,
  [productVideoActions.update.success]: (_, payload) => {
    console.log('success');
    let state = _;
    const { productVideo } = payload || {};

    if(productVideo && productVideo.url) {
      const manager = _[productVideo.manager];

      if(manager) {

        let updatedVideos = reduce(manager.videos, (videos, video) => {
          if(video.url === productVideo.url) {
            videos.push(productVideo);
          }else {
            videos.push(video);
          }
          return videos;
        }, []);

        state = {
          ..._,
          [manager.url]: {
            ...manager,
            videos: updatedVideos,
          }
        }
      }
    }

    return state;
  },
  [actions.sort.success]: (state, payload) =>  Object.assign({}, state, {[payload[entityName]['url']]: payload[entityName]}),
}, {});

export const STATE_ENABLED = 'enabled';
export const STATE_DISABLED = 'disabled';
export const STATE_DELETED = 'deleted';

export const states = {
  STATE_ENABLED,
  STATE_DISABLED,
  STATE_DELETED
};


export default {
  actions,
  workers,
  saga,
  reducer
}